import { render, staticRenderFns } from "./AdminMessages.vue?vue&type=template&id=4905bfe8&scoped=true&"
import script from "./AdminMessages.vue?vue&type=script&lang=js&"
export * from "./AdminMessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4905bfe8",
  null
  
)

export default component.exports